import { AxiosInstance } from "axios"
import { TenantSubDomain } from "mco-tenant-configurations"

export class EnvironmentClient {
	constructor(private axiosClient: AxiosInstance) {}

	public anonymiseTenant = async (confirmation: TenantSubDomain) => {
		const params = new URLSearchParams()
		params.append("confirmation", confirmation.toString())
		await this.axiosClient.post(
			`/api/admin/environment/anonymise?${params}`
		)
	}

	public enableRdsKeepAlive = async () => {
		await this.axiosClient.post(`/api/admin/environment/rdskeepalive`)
	}
}
